// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_2i-3";
export var dialog = "_2i-0";
export var divClassnameSwatch = "_2i-8";
export var flexSwatch = "_2i-4";
export var header = "_2i-1";
export var styleAttributeSwatch = "_2i-7";
export var swatch = "_2i-2";
export var textHeaderSwatch = "_2i-5";
export var webSwatch = "_2i-6";